import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITableDataHostOptions, ITableDataLayoutOptions } from 'src/app/reports/table-data/table-data.component';

@Component({
  selector: 'app-view-pay-report',
  templateUrl: './view-pay-report.component.html',
  styleUrls: ['./view-pay-report.component.scss']
})
export class ViewPayReportComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute) { }

  vm$: Observable<IViewModel>;

  ngOnInit(): void {

    this.vm$ = combineLatest([
      this.activatedRoute.queryParams
    ]).pipe(
      map(([queryParams]) => {
        const ticket: string = queryParams['ticket'];

        const curFormatter = new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD' });

        const ret: IViewModel = {
          ticket: ticket,
          hostOptions: {
            reportCode: 'affiliate-payments',
            paramOverrides: {
              affCode: ticket
            },
            paramHidden: {
              affCode: true
            },
            serviceOptions: {
              controller: 'Affiliate',
              externalLoginTicket: ticket
            }
          },
          layoutOptions: {
            groupedColumns: [
              { 
                columnName: 'Res', titleDefs: [ 
                  { columnName: 'ResNumber', title: 'CF #' },
                  { columnName: 'ConfirmNumber', title: 'Res #' }
                ]
              },
              {
                columnName: 'Passenger', titleDefs: [
                  { columnName: 'PickupDateTime', title: 'Pickup' },
                  { columnName: 'Passenger', title: 'Pax' },
                  { columnName: 'PuLocation', title: 'From' },
                  { columnName: 'DoLocation', title: 'To' }
                ]
              },
              {
                columnName: 'Details', titleDefs: [
                  { columnName: 'Hours', title: 'Hours' },
                  { columnName: 'CommBase', title: 'Comm. Base', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Earnings', title: 'Earnings', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Gratuity', title: 'Grat', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Expenses', title: 'Exp', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Other', title: 'Other', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Fees', title: 'Fees', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'Custom', title: 'Custom', formatter: (v) => curFormatter.format(v || 0.00) }
                ]
              },
              {
                columnName: 'Payment', titleDefs: [
                  { columnName: 'NetDue', title: 'Net Due', formatter: (v) => curFormatter.format(v || 0.00) },
                  { columnName: 'PaymentDate', title: 'Paid On', formatter: (v) => v || 'Pending' }
                ]
              }
            ]
          }
        };
        return ret; 
      })
    );
  }

}

interface IViewModel {
  ticket: string;
  hostOptions: ITableDataHostOptions;
  layoutOptions: ITableDataLayoutOptions;
}
